// Centralized language type definition
// When adding a new language:
// 1. Add it to this type
// 2. Update LANGUAGES constant in LanguageSelector.tsx
// 3. Update the database constraint in profiles table
// 4. Add translations to the translations table for all translation keys

export type Language = 'en' | 'es' | 'fr' | 'de' | 'pt' | 'it';

export const SUPPORTED_LANGUAGES: readonly Language[] = ['en', 'es', 'fr', 'de', 'pt', 'it'] as const;
